$(document).ready(function() {
  $('table').not('.table-steckbrief').stacktable();
});